<template>
  <div>
    <GlobalNavigation />

    <main class="py-8 mb-16">
      <BaseContainer>
        <div class="max-w-[680px] mx-auto">
          <CheckoutTermsContent />
        </div>
      </BaseContainer>
    </main>
  </div>
</template>

<script setup lang="ts">
import { useHead } from '@unhead/vue';
import { onMounted } from 'vue';

import CheckoutTermsContent from '@/components/checkout/CheckoutTermsContent.vue';
import GlobalNavigation from '@/components/globals/GlobalNavigation.vue';
import BaseContainer from '@/components/ui/BaseContainer.vue';
import { footer } from '@/data.ts';
import { useGeneralStore } from '@/stores/general';

const generalStore = useGeneralStore();

useHead({
  title: generalStore.general?.customer.alias || footer.company,
  meta: [
    {
      name: 'description',
      content: 'Find the latest events and activities happening near you.',
    },
    {
      property: 'og:title',
      content: generalStore.general?.customer.alias || footer.company,
    },
    {
      property: 'og:description',
      content: 'Find the latest events and activities happening near you.',
    },
  ],
});

// Fetch general data on mount
onMounted(() => {
  generalStore.fetchGeneral();
});
</script>
